import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface ProformaKpiCardProps {
  label: string;
  value: string;
  detail: string;
  icon: LucideIcon;
  tone?: "neutral" | "gold" | "success" | "danger";
}

export function ProformaKpiCard({
  label,
  value,
  detail,
  icon: Icon,
  tone = "neutral",
}: ProformaKpiCardProps) {
  const toneClass =
    tone === "gold"
      ? "border-brand-gold-light/60 bg-brand-gold-light/20 text-brand-gold-dark"
      : tone === "success"
        ? "border-success-border bg-success-bg text-success-text"
        : tone === "danger"
          ? "border-danger-border bg-danger-bg text-danger-text"
          : "border-border bg-surface-muted text-body";

  return (
    <div className="min-w-0 rounded-lg border border-border bg-card px-4 py-3">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-[10.5px] font-semibold uppercase tracking-wide text-muted-foreground">
            {label}
          </p>
          <p className="mt-1 break-words text-[clamp(16px,5vw,20px)] font-bold leading-tight text-foreground">
            {value}
          </p>
          <p className="mt-1 truncate text-[10.5px] text-muted-foreground">{detail}</p>
        </div>
        <span
          className={cn(
            "inline-flex size-9 shrink-0 items-center justify-center rounded-full border",
            toneClass,
          )}
        >
          <Icon size={16} />
        </span>
      </div>
    </div>
  );
}
